import { createApi } from '@reduxjs/toolkit/query/react';

import { CLIENT_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const clientApi = createApi({
    baseQuery: getBaseQuery(CLIENT_API_URL, true),
    reducerPath: 'clientApi',
    endpoints: (build) => ({
        /** Checks if supplier can claim first refusal for the provided segment */
        getCanClaimFirstRefusal: build.query<boolean, { payerId: string; segmentId: string }>({
            query: ({ payerId, segmentId }) =>
                `${payerId}/${segmentId}/first_refusal_claims/can_claim_first_refusal`,
            transformResponse: (response: { can_claim: boolean }) => response?.can_claim,
            transformErrorResponse: handleRTKQueryError(
                'An error occurred during first refusal claim check.',
            ),
        }),
    }),
});

export const { useGetCanClaimFirstRefusalQuery } = clientApi;
